var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{staticStyle:{"position":"absolute","left":"-200%","top":"0"},attrs:{"type":"text","id":"focusInput"}}),_c('ShortcutFunction')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }